import React from 'react';

export default function InventoryOverview(){
  const [rows, setRows] = React.useState<any[]>([]);
  React.useEffect(()=>{
    setRows([]);
  },[]);
  return (
    <div className="p-4">
      <h2>Inventory Overview</h2>
      {/* KPI temporarily disabled to unblock build; re-enable once component path stable */}
      <div className="card mt-3">
        <div className="card-header"><span className="card-title">Top 20 low-stock (cross-tenant)</span></div>
        <div className="card-body">
          {rows.length===0? 'No data yet' : (
            <table className="tbl"><thead><tr><th className="th-left">Tenant</th><th className="th-left">Item</th><th className="th-right">Δ</th></tr></thead>
              <tbody>
                {rows.slice(0,20).map((r:any)=> (
                  <tr key={`${r.tenantId}-${r.itemId}`}>
                    <td className="td-left">{r.tenantName||r.tenantId}</td>
                    <td className="td-left">{r.itemName||r.itemId}</td>
                    <td className="td-right delta-negative">{r.deltaToPar?.toFixed?.(2) ?? r.deltaToPar}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}


